export const InstoreServicesRoutes = [
	'/uslugi/analiz-vody/',
	'/uslugi/analiz-vody/:shop',
	'/kz/uslugi/kolerovka/',
	'/uslugi/kolerovka/',
	'/uslugi/kolerovka/:shop',
	'/uslugi/overlok/',
	'/uslugi/overlok/:shop',
	'/kz/uslugi/poshiv-shtor/',
	'/uslugi/poshiv-shtor/',
	'/uslugi/poshiv-shtor/:shop',
	'/kz/uslugi/rezka-dereva/',
	'/uslugi/rezka-dereva/',
	'/uslugi/rezka-dereva/:shop',
	'/uslugi/rezka-stekla/',
	'/uslugi/rezka-stekla/:shop',
	'/uslugi/podrezka-rulonnyh-shtor/',
	'/uslugi/podrezka-rulonnyh-shtor/:shop',
];
